import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { Stages } from 'src/app/shared/components/dashboard/stages/stages.component';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ClientsUsersService } from 'src/app/shared/services/other-services/clients-users.service';

export interface Totals {
  towns: number;
  stations: number;
  stages: Stages;
  clients: number;
  clientsBorrowed: number;
  clientsSaved: number;
  clientsPaid: number;
  clientsPaidInFull: number;
  clientsPaidInInstallment: number;
  deptRecovered: number;
  amountRecovered: number;
  amountUnPaid: number;
  floatAmount: number;
  loans: number;
  bodaDefaulters: number;
  taxiDefaulters: number;
  microDefaulters: number;
  bodaRecovery: number;
  taxiRecovery: number;
  microRecovery: number;
  bodaEnforcement: number;
  taxiEnforcement: number;
  microEnforcement: number;
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  totals: Totals = {
    towns: 12,
    stations: 10,
    stages: {boda: 5, taxi: 6},
    clients: 10,
    clientsBorrowed: 2,
    clientsSaved: 2,
    clientsPaid: 2,
    clientsPaidInFull: 2,
    clientsPaidInInstallment: 2,
    deptRecovered: 2,
    amountRecovered: 2,
    amountUnPaid: 2,
    floatAmount: 2,
    loans: 2,
    bodaDefaulters: 2,
    taxiDefaulters: 2,
    microDefaulters: 2,
    bodaRecovery: 2,
    taxiRecovery: 2,
    microRecovery: 2,
    bodaEnforcement: 2,
    taxiEnforcement: 2,
    microEnforcement: 2,
  };

  User = this.authService.loggedInUserInfo();
  inlinePlugin: any;
  textPlugin: any;

  constructor(
    private authService: AuthServiceService,
    private clientUser: ClientsUsersService
  ) { }

  ngOnInit(): void {
// inline plugin
    this.clientUser.getTotalStationLocationsByTown(this.User.userLocationId).subscribe(res => this.totals.stations = res[0].numberOfStationsInTheTown);
    this.clientUser.getTotalBodaBodaStagesByTown(this.User.userLocationId).subscribe(res => this.totals.stages.boda = res[0].numberOfBodaBodaStagesPerTown);
    this.clientUser.getTotalTaxiStagesByTown(this.User.userLocationId).subscribe(res => this.totals.stages.taxi = res[0].numberOfTaxiStagesPerTown);
    this.clientUser.getTotalClientsByTown(this.User.userLocationId).subscribe(res => this.totals.clients = res[0].numberOfCustomersPerTown);
    this.clientUser.getTotalClientsWhoBorrowedByTown(this.User.userLocationId).subscribe(res => this.totals.clientsBorrowed = res[0].numberOfCustomersBorrowedTodayPerTown);
    this.clientUser.getTotalClientsWhoSavedByTown(this.User.userLocationId).subscribe(res => this.totals.clientsSaved = res[0].numberOfCustomersSavedTodayPerTown);
    this.clientUser.getTotalClientsWhoPaidByTown(this.User.userLocationId).subscribe(res => this.totals.clientsPaid = res[0].numberOfCustomersPaidTodayByTown);
    // this.clientUser.getTotalNoOfClientPaidInFullByTown(this.User.userLocationId).subscribe(res => this.totals.clientsPaidInFull = res[0]);
    // this.clientUser.getTotalNoOfClientPaidInInstalmentByTown(this.User.userLocationId).subscribe(res => this.totals.clientsPaidInInstallment = res[0]);
    // this.clientUser.getTotalNoOfDebtsRecoveredByTown(this.User.userLocationId).subscribe(res => this.totals.deptRecovered = res[0]);
    // this.clientUser.getTotalAmountRecoveredByTown(this.User.userLocationId).subscribe(res => this.totals.amountRecovered = res[0]);
    // this.clientUser.getTotalAmountUnPaidByTown(this.User.userLocationId).subscribe(res => this.totals.amountUnPaid = res[0]);
    // this.clientUser.getTotalFloatAmountByTown(this.User.userLocationId).subscribe(res => this.totals.floatAmount = res[0]);
    // this.clientUser.getTotalLoansByTown(this.User.userLocationId).subscribe(res => this.totals.loans = res[0]);
    this.clientUser.getTotalBodaBodaLoanDefaultersByTown(this.User.userLocationId).subscribe(res => this.totals.bodaDefaulters = res[0].totalBodaBoadLoanDefaultersByTown);
    this.clientUser.getTotalTaxiLoanDefaultersByTown(this.User.userLocationId).subscribe(res => this.totals.taxiDefaulters = res[0].totalTaxiLoanDefaultersByTown);
    this.clientUser.getTotalMicroLoanDefaultersByTown(this.User.userLocationId).subscribe(res => this.totals.microDefaulters = res[0].totalMicroloanDefaultersByRegion);
    this.clientUser.getTotalBodaBodaLoanRecoveryByTown(this.User.userLocationId).subscribe(res => this.totals.bodaRecovery = res[0].totalBodaBodaLoanRecoveryByTown);
    this.clientUser.getTotalTaxiLoanRecoveryByTown(this.User.userLocationId).subscribe(res => this.totals.taxiRecovery = res[0].totalTaxiLoanRecoveryByTown);
    this.clientUser.getTotalMicroLoanRecoveryByTown(this.User.userLocationId).subscribe(res => this.totals.microRecovery = res[0].totalMicrolaonRecoveryByTown);
    this.clientUser.getTotalBodaBodaLoanEnforcementByTown(this.User.userLocationId).subscribe(res => this.totals.bodaEnforcement = res[0].totalBodaBodaLoanEnforcementByTown);
    this.clientUser.getTotalTaxiLoanEnforcementByTown(this.User.userLocationId).subscribe(res => this.totals.taxiEnforcement = res[0].totalTaxiLoanEnforcementByTown);
    this.clientUser.getTotalMicroLoanEnforcementByTown(this.User.userLocationId).subscribe(res => this.totals.microEnforcement = res[0].totalMicroLoanEnforcementByTown);
  }
}
